import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getMediumImage } from '../../utils/prismic';
import Title from '../../components/Header/parts/Title';

const linkResolver = require('../../../config/linkResolver');

const LogoList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: space-around;
  justify-items: center;
  padding: 4rem 2.4rem;
`;
const LogoItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  max-width: 20vw;
  max-height: 25vw;

  padding: 2.4rem;
  flex-grow: 1;
  flex-shrink: 1;
  text-align: center;
  img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 33%;
    overflow: hidden;
    transform: scale(0.9);
    transition: transform 0.8s cubic-bezier(0, 1, 0, 1);
  }
  h5 {
    opacity: 0.56;
    font-weight: bold;
  }
  &:hover {
    img {
      transform: scale(1.1);
    }
    h5 {
      opacity: 1;
    }
  }
`;

const HeroClients = ({ input }) => {
  //console.log(input.primary);

  const source = input.items.map(({ client }) => client.document);

  //console.log(source);

  const logos = source.map(x => {
    //console.log(x && x.data.client_avatar);
    return x && x.data.client_avatar ? (
      <LogoItem key={x.id}>
        <Link to={linkResolver(x)}>
          <img
            src={getMediumImage(x.data.client_avatar).url}
            alt={getMediumImage(x.data.client_avatar).alt}
            width={getMediumImage(x.data.client_avatar).width}
            height={getMediumImage(x.data.client_avatar).height}
          />
          <h5 style={{ marginTop: '1.6rem' }}>
            {x.data.client_alias || x.data.client_name}
          </h5>
        </Link>
      </LogoItem>
    ) : null;
  });

  return (
    <>
      <Title
        title={input.primary.title.html}
        subtitle={input.primary.subtitle.html}
        description={input.primary.description.html}
        title_align={input.primary.align_text}
      />
      <LogoList>{logos}</LogoList>
    </>
  );
};

HeroClients.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroClients;
